import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { StatusConexaoEnum } from '../../../shared/enums/integracao-financas-banco/status-conexao.enum';
import { TipoContaEnum } from '../../../shared/enums/financas/tipo-conta.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { ConciliacaoBancariaService } from '../../../shared/services/apis/financas/conciliacao-bancaria.service';
import { ExtratoBancarioContaItem } from '../../../shared/services/responses/financas/extrato-bancario-contas.response';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExtratoService } from '../../../shared/services/apis/integracao-financas-banco/extrato.service';

@Component({
  selector: 'app-conciliacao-bancaria-contas',
  standalone: true,
  imports: [
    HeaderComponent,
    EmptyListComponent,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    LoadingBoxComponent,
  ],
  templateUrl: './conciliacao-bancaria-contas.component.html',
  styleUrls: ['./conciliacao-bancaria-contas.component.css'],
})
export class ConciliacaoBancariaContasComponent implements OnInit {
  moduloEnum = ModuloEnum.Financas;
  funcionalidadeEnum = FuncionalidadeEnum.Financas_ConciliacaoBancaria;
  statusConexaoEnum = StatusConexaoEnum;

  _contas: ExtratoBancarioContaItem[] = [];
  isLoading: boolean = false;
  tipoContaEnum = TipoContaEnum;

  get contasBancarias(): ExtratoBancarioContaItem[] {
    return this._contas.filter(c => c.idTipoConta !== TipoContaEnum.CartaoCredito);
  }

  get contasCartao(): ExtratoBancarioContaItem[] {
    return this._contas.filter(c => c.idTipoConta === TipoContaEnum.CartaoCredito);
  }

  private _statusPorConta = new Map<number, number>();

  constructor(
    private conciliacaoBancariaService: ConciliacaoBancariaService,
    private extratoService: ExtratoService,
    private alertService: AlertService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.carregarContas();
  }

  private carregarContas(): void {
    if (this.isLoading) return;
    this.isLoading = true;
    this.conciliacaoBancariaService.getContas().subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this._contas = res.contas;
        this.carregarStatusIntegracao();
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro', err.message, AlertType.error);
      },
    });
  }

  private carregarStatusIntegracao(): void {
    const listIdContaFinanceira = this._contas.map(c => c.idContaFinanceira);
    if (!listIdContaFinanceira.length) return;
    this.extratoService.getStatusExtratoContas(listIdContaFinanceira).subscribe({
      next: res => {
        if (res.isError) return;
        res.contas.forEach(c => this._statusPorConta.set(c.idContaFinanceira, c.idStatusConexao));
      },
    });
  }

  getStatusIntegracaoExtrato(conta: ExtratoBancarioContaItem): 'conectado' | 'conectando' | 'disponivel' | null {
    const status = this._statusPorConta.get(conta.idContaFinanceira);
    if (status === StatusConexaoEnum.Conectado) return 'conectado';
    if (status === StatusConexaoEnum.Conectando) return 'conectando';
    if (!status && conta.suportaExtratoOpenFinance) return 'disponivel';
    return null;
  }

  navegarParaLancamentos(conta: ExtratoBancarioContaItem): void {
    const rota = conta.idTipoConta === TipoContaEnum.CartaoCredito
      ? '/financas/conciliacao-bancaria/cartao/lancamentos'
      : '/financas/conciliacao-bancaria/lancamentos';
    this.router.navigate([rota, conta.idContaFinanceira], { state: { conta } });
  }

  irParaConfiguracaoIntegracao(conta: ExtratoBancarioContaItem, $event: Event): void {
    $event.stopPropagation();
    this.router.navigate(
      ['/configuracoes/financas/contas-financeiras/cadastrar', conta.idContaFinanceira],
      { queryParams: { abrirIntegracao: true } }
    );
  }

  adicionarConta(): void {
    window.open('/configuracoes/financas/contas-financeiras/cadastrar', '_blank');
  }

  atualizarLista(): void {
    this._statusPorConta.clear();
    this.carregarContas();
  }
}
